import { FC } from 'react';
import { BlockPage, BlockPageProps } from '../../../routings/pages/BlockPage/BlockPage';
import { Icons } from '@silverfort/sf-components';
import BlockPageMainImage from '../Images/blockPageImage.png';

const topics: BlockPageProps['rightContent']['topics'] = [
    'Manage, enroll, and match your users to singular identities for a seamless and secure experience',
    'Bring your Tokens and get agentless end-to-end MFA coverage everywhere',
    'Create, define, and prioritize policies based on a variety of attributes and parameters',
    'Leverage the Authentication Firewall to enable precise blocking of dangerous protocols'
];

const PolicyBlockPage: FC = () => {
    return (
        <BlockPage
            leftContent={{
                title: 'Protection',
                image: BlockPageMainImage,
                titleIntroText: 'Discover'
            }}
            rightContent={{
                topics,
                icon: Icons.UserGroupEdit,
                accessLink: 'https://www.silverfort.com/mfa-firewall-signup/?utm_source=PQL&utm_content=main',
                title: 'Protect Authentication with Policies',
                description: 'Extend protection to all resources using MFA or blocking capabilities.',
                badgeProps: {
                    text: 'Unified module',
                    color: 'neutral'
                }
            }}
        />
    );
};

export default PolicyBlockPage;
